/**
* empty data component for the dashboard
*
* Created by Tom on 12/06/18
*/

import React from 'react'
import PropTypes from 'prop-types'

// icon imports
import SearchIcon from '../../assets/svg/searching.svg'

// style import
import './style.scss'


const EmptyData = ({headerText}) => {
    return (
        <div className="empty-data">

            <p className="empty-data__header-text">
                {headerText}
            </p>

            <img
                src={SearchIcon}
                className="empty-data__icon"
                alt="Empty data icon" />

            <p className="empty-data__nodata-text">
                NO DATA AVAILABLE
            </p>

            <p className="empty-data__notification-text">
                In order to see data here you must sign your SMSF documentation,
                roll over funds into your new CMA and start investing your funds money.
            </p>
        </div>
    )
}

// define the prop types
EmptyData.propTypes = {
    headerText: PropTypes.string
}

export default EmptyData



// WEBPACK FOOTER //
// ./src/components/EmptyData/index.js